import * as React from "react";
import { DynamicModuleLoader } from "redux-dynamic-modules";
import { profileModule } from "../../../modules/manage-profile/redux/profile";
import { OnBoardingEnthusiast as ConnectedOnBoardingEnthusiast } from "../../../modules/manage-profile/onboarding-enthusiast";

export const OnBoardingEnthusiast = () => (
  <DynamicModuleLoader modules={[profileModule]}>
    <ConnectedOnBoardingEnthusiast />
  </DynamicModuleLoader>
);
